import { render, staticRenderFns } from "./newMobile.vue?vue&type=template&id=1f77e82f&scoped=true&"
import script from "./newMobile.vue?vue&type=script&lang=js&"
export * from "./newMobile.vue?vue&type=script&lang=js&"
import style0 from "./newMobile.vue?vue&type=style&index=0&id=1f77e82f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f77e82f",
  null
  
)

export default component.exports